<template>
  <div id="google-signin-button" @click="click = true"></div>
</template>

<script>
import functions from "./functions.js";

export default {
  mixins: [functions],
  data() {
    return {
      click: false
    };
  },
  mounted() {
    gapi.signin2.render("google-signin-button", {
      width: 25,
      height: 25,
      onsuccess: this.onSignIn
    });
  },
  methods: {
    onSignIn(user) {
      if (this.click) {
        let profile = user.getBasicProfile();
        this.socLogin(
          profile.ofa,
          profile.wea,
          profile.Eea,
          profile.Paa,
          profile.U3,
          "Google"
        );
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/social/google.vue